import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    root: {
        flexGrow: 1,
        display: 'grid',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    input:{
        flex: 1,
        margin: theme.spacing(1)
    },
    row: {
        display: 'flex',
        alignItems: 'center',
    },
    switch: {
        margin: theme.spacing(1, 2)
    },
    textarea: {
        display: 'grid',
        gap: theme.spacing(1)
    },
    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    rootFab: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        }
    },
    container: {
        display: 'flex',
        justifyContent: "flex-end",
    },
    modal: {
        display: 'flex',
        flexDirection: 'column',
    },
    buttons: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2)
    },
    button: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    [theme.breakpoints.up('md')]: {
        root: {
            gridTemplateColumns: '1fr 1fr'
        }
    }
}));

